import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
import config from "@/lib/config";
import Cookies from "@/lib/cookies";
import debugLog from "@/lib/debugLog";
import getRemoteIpAddress from "@/lib/getRemoteIpAddress";
import { SOAPDataSource } from "apollo-datasource-soap";
import { v4 as uuidv4 } from "uuid";

/**
 * @typedef {Object} RecommendResult
 * @property {string} elementId
 * @property {string} sessionId
 * @property {string} content
 */

/**
 * @type {Object} AbstractParamsAttributes
 * @property {string} accountId
 */

/**
 * @typedef {Object} AbstractParams
 * @property {AbstractParamsAttributes} attributes
 * @property {string} member - ユニークユーザーID
 * @property {string} ipAddress - IPアドレス
 * @property {string} location - アクセスしたページのURL
 * @property {string} userAgent - ユーザーエージェント
 */

/**
 * @type {string}
 */
const RTOASTER_API_URL = "https://rt.rtoaster.jp/api/engine?wsdl";

/**
 * Rtoasterとの通信クラス.
 *
 * @constructor
 */
var _abstractParams = /*#__PURE__*/new WeakSet();
class Rtoaster extends SOAPDataSource {
  constructor(options) {
    super(RTOASTER_API_URL, options);
    /**
     * get abstractParams.
     * @returns {AbstractParams}
     */
    _classPrivateMethodInitSpec(this, _abstractParams);
    this.context = options;
  }

  /**
   * track.
   *
   * @param {string} location
   * @param {string} referrer
   * @param {object} options
   * @returns {Promise<void>}
   */
  async track(location, referrer) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    const params = (() => {
      const params = _classPrivateMethodGet(this, _abstractParams, _abstractParams2).call(this, location);
      if (referrer) {
        params.referrer = referrer;
      }
      if (options) {
        const list = Object.keys(options).map(key => {
          return {
            attributes: {
              name: key
            },
            $value: options[key]
          };
        });
        params.appKey = list;
      }
      return params;
    })();
    debugLog("rtoaster track", JSON.stringify(params, null, 2));
    return await this.invoke("track", {
      data: params
    });
  }

  /**
   * recommend.
   *
   * @param {string} location
   * @param {string[]} elementId
   * @returns {Promise<RecommendResult[]>}
   */
  async recommend(location, elementId) {
    return await this.invoke("recommend", {
      query: _objectSpread(_objectSpread({}, _classPrivateMethodGet(this, _abstractParams, _abstractParams2).call(this, location)), {
        elementId
      })
    });
  }
}
function _abstractParams2(location) {
  var _req$deviceInfo;
  const {
    req,
    res
  } = this.context;
  const member = (() => {
    if (req.userToken) {
      var _req$userToken;
      return (_req$userToken = req.userToken) === null || _req$userToken === void 0 ? void 0 : _req$userToken.hashedUserId;
    } else {
      // uuidv4
      // cookieから読む、なければ生成して保存
      const cookies = new Cookies(req, res);
      const rtid = cookies.get(config.rtoaster.uuidCookieName);
      if (rtid) {
        return rtid;
      } else {
        const uuid = uuidv4();
        cookies.set({
          name: config.rtoaster.uuidCookieName,
          value: uuid
        });
        return uuid;
      }
    }
  })();
  const ipAddress = getRemoteIpAddress(req);
  const userAgent = req === null || req === void 0 || (_req$deviceInfo = req.deviceInfo) === null || _req$deviceInfo === void 0 ? void 0 : _req$deviceInfo.ua;
  return {
    attributes: {
      accountId: config.rtoaster.accountId
    },
    member,
    ipAddress,
    userAgent,
    location
  };
}
export default Rtoaster;